import { deleteOrderByOrderNoApi, toOperateApi } from '@/api/myOrder'
import { $confirm } from '@/components/installer/defaultComfirm'
import { $alert } from '@/components/installer/defaultAlert'
import { $loading } from '@/components/installer/appLoading'
import { showToast } from 'vant'
import { showTop } from '@/utils/navitiveApi/common'
import { matchPhone } from '@/utils/tools'

const { isIOS, isAndroid } = matchPhone()

interface OrderConfigOptions {
    reloadList?: () => void
}

export const useOrderConfig = (options: OrderConfigOptions): any => {
    const { reloadList } = options

    const CLASS_ACTIVE = 'status-active'
    const CLASS_FINISHED = 'status-finished'
    const CLASS_CLOSED = 'status-close'

    const getOrderFilter = (type: string, list: any[]) => {
        switch (type) {
            case 'active':
                return list.filter(
                    (data: any) => data.status >= 1 && data.status <= 5,
                )
            case 'finished':
                return list.filter(
                    (data: any) => data.status >= 6 && data.status <= 7,
                )
            case 'closed':
                return list.filter(
                    (data: any) => data.status >= 8 && data.status <= 10,
                )
            default:
                return () => list
        }
    }

    // 删除订单
    const onCancelOrder = async (orderNo: string) => {
        try {
            await $confirm({
                message: '是否确认取消订单？',
            }).then(async () => {
                $loading.openLoading()
                try {
                    const { code, message } = await deleteOrderByOrderNoApi({
                        orderNo,
                    })

                    $loading.closeLoading()
                    if (code !== 9000) {
                        $alert({
                            message,
                        })
                        return
                    }

                    await reloadList?.()
                    showToast({
                        message: '取消成功',
                    })
                } catch (error) {
                    console.error(error)
                }
            })
        } catch (error) {
            // cancel
            // showToast({
            //     message: '订单已取消',
            // })
            console.error(error)
        }
    }

    // 其他操作
    const toOperate = async (orderNo: string, status: number) => {
        $loading.openLoading()
        try {
            const { code, message, data } = await toOperateApi({
                orderNo,
                status,
            })

            if (code !== 9000) {
                $loading.closeLoading()
                $alert({
                    message,
                })
                return false
            }

            return data
        } catch (error) {
            console.error(error)
        }
        return false
    }

    // 立即支付
    const onPay = async (orderNo: string, status: number) => {
        const res = await toOperate(orderNo, status)
        console.info('res', res);
        if (res) {
            const { payUrl } = res
            console.info('payUrl', payUrl)
            window.location.href = payUrl
            // window.open(payUrl, '_blank')
        }
    }
    // 立即认证
    const onCertify = async (orderNo: string, status: number) => {
        const res = await toOperate(orderNo, status)
        if (res) {
            const { insuredUploadUrl, waitSignUrl } = res
            window.location.href = status === 2 ? insuredUploadUrl : waitSignUrl
        }
    }

    return {
        getOrderFilter,
        orderConfigMap: {
            1: {
                statusName: '核保中',
                nameClass: CLASS_ACTIVE,
            },
            2: {
                statusName: '待认证',
                nameClass: CLASS_ACTIVE,
                actions: [
                    {
                        label: '取消订单',
                        type: 'cancel',
                        onClick: onCancelOrder,
                    },
                    {
                        label: '立即认证',
                        type: 'confirm',
                        onClick: onCertify,
                    },
                ],
            },
            3: {
                statusName: '待认证',
                nameClass: CLASS_ACTIVE,
                actions: [
                    {
                        label: '取消订单',
                        type: 'cancel',
                        onClick: onCancelOrder,
                    },
                    {
                        label: '立即认证',
                        type: 'confirm',
                        onClick: onCertify,
                    },
                ],
            },
            4: {
                statusName: '待支付',
                nameClass: CLASS_ACTIVE,
                actions: [
                    {
                        label: '取消订单',
                        type: 'cancel',
                        onClick: onCancelOrder,
                    },
                    {
                        label: '立即支付',
                        type: 'confirm',
                        onClick: onPay,
                    },
                ],
            },
            5: {
                statusName: '待支付',
                nameClass: CLASS_ACTIVE,
            },
            6: {
                statusName: '已支付',
                nameClass: CLASS_FINISHED,
            },
            7: {
                statusName: '已完成',
                nameClass: CLASS_FINISHED,
            },
            8: {
                statusName: '已关闭',
                nameClass: CLASS_CLOSED,
            },
            9: {
                statusName: '已关闭',
                nameClass: CLASS_CLOSED,
            },
            10: {
                statusName: '已关闭',
                nameClass: CLASS_CLOSED,
            },
        },
    }
}
